import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
//import AgregarSolicitudInterna from './AgregarSolicitudInterna';
//import ModificarSolicitudInterna from './ModificarSolicitudInterna';
import { notificar } from '../../components/SistemaToast/notificar';
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa";
import {getCurrentDate,urlApiProd,eliminarDiacriticosEs,print} from '../utiles';
import moment from 'moment';
import { Modal, Button, Spinner, Badge, Card, Col, Form, Row } from 'react-bootstrap';

const MESES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const handleRowClicked = row => {
    print(`Row clicked:`, row);
  };

const CargarPreciosFletes = ({ solicitudes = [], solicitudesInternas = [], puertos = [], ffw = [], carriers = [], cerrar, embedded = false }) => {
    const [formData, setFormData] = useState({
        fecha_creacion: '',
                        ffw: '',
                        armador: '',
                        pol : '',
                        pod: '',
                        frete: '',
                        freetime_origen: '',
                        freetime_destino: '',
                        validade: '',
                        transittimi: '',
    });
    const [cantidadMaxima, setCantidadMaxima] = useState(null);
    const [solicitudInterna, setSolicitudInterna] = useState(null);
    const [pedidoCompletado, setPedidoCompletado] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [filterText, setFilterText] = useState('');
    const hoy = new Date();
    const [filterMonth, setFilterMonth] = useState(String(hoy.getMonth() + 1));
    const [filterYear, setFilterYear] = useState(String(hoy.getFullYear()));
    const [filterEstado, setFilterEstado] = useState('');
    const [dataPreciosfletes, setDataPreciosfletes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [apoyo, setApoyo] = useState(undefined);
    const [principal, setPrincipal] = useState(undefined);
    const firstRender = useRef(true);
    const [showAgregar, setShowAgregar] = useState(false);
    const [show, setShow] = React.useState(true);
    const [loading, setLoading] = useState(true);
    const years = Array.from(new Set([
        String(new Date().getFullYear()),
        ...dataPreciosfletes
            .map(precio => String(precio.fecha_creacion || '').slice(0, 4))
            .filter(year => /^\d{4}$/.test(year)),
    ])).sort((a, b) => Number(b) - Number(a));


        useEffect(() => {
            if (firstRender.current) {
                setLoading(true);
                fetchData();
                firstRender.current = false;
            }
        }, []);
    
        
            const handleClose = () => {setShow(false);
                cerrar();
            };
    

    const fetchData = async () => {
        const token = localStorage.getItem('token');
        try {
            // Fetch Solicitudes Internas
            const responsepreciosfletes = await fetch(`${urlApiProd}/preciosfletes`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!responsepreciosfletes.ok) throw new Error('Error fetching preciosfletes');
            const data= await responsepreciosfletes.json();
            setDataPreciosfletes(data);
            //setTotalItems(total);
        } catch (error) {
            console.error('Error en fetchData:', error.message);
            setPrincipal(false); // Indica que la solicitud principal falló
            notificar.error(`preciosfletes no cargados: ${error.message}`, { toastId: 'error-principal' });
        } finally{
            setLoading(false);
        }
    };

    useEffect(() => {
        print('Filtrando con:', { filterText, filterMonth, filterYear });
        const filtered = Array.isArray(dataPreciosfletes)
            ? dataPreciosfletes.filter(precioFlete => {
                const [year, month] = String(precioFlete.fecha_creacion || '').split('-');
                const matchesMonth = month === String(filterMonth).padStart(2, '0');
                const matchesYear = year === String(filterYear);

                return matchesMonth && matchesYear;
            })
            : [];
        setFilteredData(filtered);
    }, [dataPreciosfletes, filterText, filterEstado, filterMonth, filterYear]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleChangeLimited = (e, max) => {
        const { name, value } = e.target;
        const numericValue = parseInt(value, 10);
    
        if (isNaN(numericValue) || numericValue <= 0) {
            alert('Por favor, ingrese un número válido mayor a 0.');
            return;
        }
    
        if (numericValue <= max) {
            setFormData({ ...formData, [name]: numericValue });
        } else {
            alert(`El valor máximo permitido es ${max} días.`);
        }
    };

    const columns = [
        {
            name: 'Origen',
            selector: row => puertos.find(puerto => puerto.id_puerto === row.pol)?.nombre || 'Desconocido',  sortable: true
        },
        {
            name: 'Destino',
            selector: row => puertos.find(puerto => puerto.id_puerto === row.pod)?.nombre || 'Desconocido',  sortable: true
        },
        {
            name: 'FFW',
            selector: row => row.ffw!=-1 ? ffw.find(ffw => ffw.id_ffw === row.ffw)?.nombre : 'Sin FFW',  sortable: true
        },
        {
            name: 'Carrier',
            selector: row => carriers.find(carrier => carrier.id_carrier === row.armador)?.nombre || 'Desconocido',  sortable: true
        },
        { name: 'Fecha Creación', selector: row => row.fecha_creacion,  sortable: true },
        { name: 'Frete', selector: row => row.frete, sortable: true},
        { name: 'Free Time Origen', selector: row => row.freetime_origen },
        { name: 'Free Time Destino', selector: row => row.freetime_destino },
        { name: 'Validade', selector: row => row.validade, sortable: true},
        { name: 'Transittimi', selector: row => row.transittimi, sortable: true},
        { name: 'Acciones',
                    cell: row => (
                        <div>
                                <button
                                    className='btn btn-outline-danger'
                                    onClick={() => {
                                        if (window.confirm('¿Estás seguro de eliminar este precio de flete?')) {
                                            handleEliminar(row.id);
                                        }
                                    }}
                                >
                                    <IoTrashOutline />
                                </button>
                        </div>
                    ),
                    ignoreRowClick: true,
                }
    ];

    const handleChangeSolicitudInterna = (e) => {
        const { name, value } = e.target;
        const solicitud_interna = solicitudesInternas.find((solicitud) => solicitud.id_solicitudinterna === parseInt(value, 10));
        if(solicitud_interna){
            setSolicitudInterna(solicitud_interna);
            const solicitudesAsociadas = solicitudes.filter((solicitud) => solicitud.solicitud_interna.id === solicitud_interna.id_solicitudinterna);
            setCantidadMaxima(solicitud_interna.cantidad - (solicitudesAsociadas.reduce((acc, solicitud) => acc + solicitud.cantidad, 0)));
            setFormData({ ...formData, [name]: value, etd: solicitud_interna.etd, id_puerto_destino: solicitud_interna.id_puerto_destino });
        }
    }

    const handlePageChange = (page) => {
        fetchData();
    };


    const handleChangeCantidad = (e) => {
        const { name, value } = e.target;
        if(solicitudInterna && cantidadMaxima){
            if(parseInt(value, 10) <= cantidadMaxima){
                setFormData({ ...formData, [name]: value });
                if(cantidadMaxima - parseInt(value, 10) === 0){
                    setPedidoCompletado(true);
                }
                if(cantidadMaxima - parseInt(value, 10) > 0){
                    setPedidoCompletado(false);
                }
            } else {
                alert(`La cantidad máxima permitida es ${cantidadMaxima}`);
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    }

    function getJsDateFromExcel(excelDate) {

        // JavaScript dates can be constructed by passing milliseconds
        // since the Unix epoch (January 1, 1970) example: new Date(12312512312);
      
        // 1. Subtract number of days between Jan 1, 1900 and Jan 1, 1970, plus 1 (Google "excel leap year bug")             
        // 2. Convert to milliseconds.
      
          return new Date((excelDate - (25567 + 1))*86400*1000);
      
      }

      const handleEliminar = async (id) => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/deleteprecioflete/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Error eliminando precioFlete');
            alert('Precio Flete exitosamente');
            fetchData();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo eliminar Precio Flete');
        }
    };

    const handleAgregarPreciosFletes = () => setShowAgregar(true);

    const handleUpload = async (e) => {
        print('reading input file:');
        const file = e.target.files[0];
        const data = await file.arrayBuffer();
        setLoading(true);
        const workbook = XLSX.read(data);
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            defval: "",
        });

        //var cleanjsonData = jsonData.filter((arr, index, self) => index === self.findIndex((t) => (t.save === arr.save && t.State === arr.State)))
       //var cleanjsonData = jsonData;
        var cleanjsonData = Array.from(new Set(jsonData.map(JSON.stringify))).map(JSON.parse);

        var registrosError = [];
        var registrosExistentes = [];

        //print(cleanjsonData[0][0]);
        if(cleanjsonData[0][0]==='FFW'){
        //procesar cada fila
        for(var k in cleanjsonData) {
            //print(jsonData[k]);

            if(cleanjsonData[k][0]==='FFW'){} else if(cleanjsonData[k][0]!==''){
              
                let fecha_validade = moment(getJsDateFromExcel(cleanjsonData[k][7]));
                let converted_date = fecha_validade.format('YYYY-MM-DD');
                //let converted_date = new Date(Math.round((jsonData[k][7] - 25569) * 864e5));
                //converted_date = moment(converted_date).format('YYYY-MM-DD');

                var id_ffw =  ffw.find(ffw => eliminarDiacriticosEs(ffw.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][0].toUpperCase().trim()))?.id_ffw || -2;
                var id_carrier = carriers.find(carrier => eliminarDiacriticosEs(carrier.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][1].toUpperCase().trim()))?.id_carrier || -2;
                var id_puerto_origen = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][2].toUpperCase().trim()))?.id_puerto || -2;
                var id_puerto_destino = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][3].toUpperCase().trim()))?.id_puerto || -2;

                print(`id_ffw ${id_ffw} id_carrier ${id_carrier} id_puerto_origen ${id_puerto_origen} id_puerto_destino ${id_puerto_destino} fecha_validade ${fecha_validade}`);

                if(id_carrier===-2 || id_puerto_origen===-2 || id_puerto_destino===-2 || id_ffw===-2 || fecha_validade<moment()){
                    registrosError.push(`fila ${parseInt(k)+1} data: ${cleanjsonData[k]}\n`);
                } else if((dataPreciosfletes.findIndex(precioFlete => precioFlete.ffw===id_ffw && precioFlete.armador===id_carrier && precioFlete.pol===id_puerto_origen && precioFlete.pod===id_puerto_destino && precioFlete.frete===cleanjsonData[k][4] && precioFlete.validade===converted_date)!=-1)){
                    print("registrosExistentes");
                    registrosExistentes.push(`fila ${parseInt(k)+1} data: ${cleanjsonData[k]}\n`);    
                }else{

                    print(`frete ${cleanjsonData[k][4]} freetime_origen ${cleanjsonData[k][5]} freetime_destino ${cleanjsonData[k][6]} validade ${converted_date} transittimi ${cleanjsonData[k][8]}`);

                    var precioFleteRaw = {
                        fecha_creacion: getCurrentDate(),
                        ffw: id_ffw,
                        armador: id_carrier,
                        pol : id_puerto_origen,
                        pod: id_puerto_destino,
                        frete: Number(cleanjsonData[k][4]),
                        freetime_origen: cleanjsonData[k][5],
                        freetime_destino: cleanjsonData[k][6],
                        validade: converted_date,
                        transittimi: cleanjsonData[k][8],
                    };

                    const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${urlApiProd}/addpreciosfletes`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(precioFleteRaw)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al agregar precio de flete');
            } 
            //else alert('Precio de flete agregado exitosamente');
            /*
            if(pedidoCompletado && response.ok){
                const responseSolicitudInterna = await fetch(`https://api.dvstarlab.com/editsolicitudinterna/${solicitudInterna.id_solicitudinterna}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ ...solicitudInterna, estado: 1 })
                });
                if (!responseSolicitudInterna.ok) {
                    const errorData = await responseSolicitudInterna.json();
                    throw new Error(errorData.error || 'Error al editar la solicitud interna');
                }
                alert('Solicitud Interna completada exitosamente');
            }else if(pedidoCompletado && !response.ok){
                alert('No se pudo completar la solicitud interna modificar manualmente');
            }
            cerrar();
            */
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo agregar precios de flete');
        }


        
        
                }
        }
         }

         fetchData();

         if(registrosError.length>0 || registrosExistentes.length>0){
            var error = registrosError.length>0 ? `Existen ${registrosError.length} registros con error, favor revisar y volver a cargar.\n ${registrosError}\n` : '';

            var existen = registrosExistentes.length>0 ? `Existen ${registrosExistentes.length} registros ya existentes, favor revisar y volver a cargar.\n ${registrosExistentes}` : '';

            alert(`${error}${existen}`);
         }
        } else{
            setLoading(false);
            alert(`Favor validar archivo seleccionado`);
        }
    
        //print(e.target.files[0]);
        //print(workbook);
        
    }

    const contenido = loading ? (
        <div className="text-center">
            <Spinner animation="border" role="status" />
            <span className="sr-only">Cargando...</span>
        </div>
    ) : (
        <div>
            <Row className="g-3 mb-3">
                <Col xs={12} md={4}>
                    <Form.Group controlId="filtro-mes-fletes">
                        <Form.Label>Mes</Form.Label>
                        <Form.Select value={filterMonth} onChange={event => setFilterMonth(event.target.value)}>
                            {MESES.map((mes, index) => (
                                <option key={mes} value={String(index + 1)}>{mes}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                    <Form.Group controlId="filtro-anio-fletes">
                        <Form.Label>Año</Form.Label>
                        <Form.Select value={filterYear} onChange={event => setFilterYear(event.target.value)}>
                            {years.map(year => <option key={year} value={year}>{year}</option>)}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationPerPage={10}
                onChangePage={handlePageChange}
                highlightOnHover
                responsive
            />
            Cargar Precios de Fletes<br />
            <input id="fileUploadPreciosFletes" type="file" onInput={(e) => { handleUpload(e); e.target.value = null; }} />
        </div>
    );

    if (embedded) {
        return (
            <Card className="mb-4">
                <Card.Header as="h4">Precios de Fletes</Card.Header>
                <Card.Body>{contenido}</Card.Body>
            </Card>
        );
    }

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="my-modal" size='xl' backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Precios de Fletes</Modal.Title>
              </Modal.Header>
              <Modal.Body>{contenido}</Modal.Body>
            </Modal>
    );
};

export default CargarPreciosFletes;
